// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".magnifier_j9rjC{display:inline-block;display:flex;max-height:100%;position:relative}.magnifier_j9rjC img{vertical-align:middle}.magnifierLayer_bW49L{background-color:var(--cp-white);background-repeat:no-repeat;position:absolute;z-index:11}.magnifierZoom_UwPit{left:0;pointer-events:none;position:absolute;top:0;touch-action:none;z-index:10}.zoomDefault_K8xFT{background-color:var(--cp-white);opacity:.5}.bigDefault_oum3I{border-radius:4px;filter:drop-shadow(0 0 8px var(--cp-color-97));left:100%;margin-left:16px;top:0}.bigInternalDefault_zoyZN{bottom:0;left:0;right:0;top:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"magnifier": "magnifier_j9rjC",
	"magnifierLayer": "magnifierLayer_bW49L",
	"magnifierZoom": "magnifierZoom_UwPit",
	"zoomDefault": "zoomDefault_K8xFT",
	"bigDefault": "bigDefault_oum3I",
	"bigInternalDefault": "bigInternalDefault_zoyZN"
};
module.exports = ___CSS_LOADER_EXPORT___;
